import React, { useState } from 'react';
import Button from '../../../components/ui/Button';

import { cn } from '../../../utils/cn';

const BulkActionsToolbar = ({
  selectedCount,
  onBulkDelete,
  onBulkRoleUpdate,
  onBulkStatusUpdate,
  onDeselectAll
}) => {
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);

  if (selectedCount === 0) {
    return null;
  }

  const handleRoleUpdate = (role) => {
    onBulkRoleUpdate?.(role);
    setIsRoleDropdownOpen(false);
  };

  const handleStatusUpdate = (status) => {
    onBulkStatusUpdate?.(status);
    setIsStatusDropdownOpen(false);
  };

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
            <span className="text-blue-900 font-medium">
              {selectedCount} user{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onDeselectAll}
            className="text-blue-700 hover:text-blue-900"
          >
            Clear Selection
          </Button>
        </div>

        <div className="flex items-center space-x-2">
          {/* Role Update Dropdown */}
          <div className="relative">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
              iconName="UserCog"
              iconPosition="left"
              className="text-sm"
            >
              Update Role
              <svg 
                className={cn(
                  "ml-2 h-4 w-4 transition-transform",
                  isRoleDropdownOpen && "rotate-180"
                )} 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </Button>
            
            {isRoleDropdownOpen && (
              <div className="absolute top-full left-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-border z-10">
                <div className="py-1">
                  <button
                    onClick={() => handleRoleUpdate('admin')}
                    className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                      <span>Admin (Full Access)</span>
                    </div>
                  </button>
                  <button
                    onClick={() => handleRoleUpdate('manager')}
                    className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                      <span>Manager (Member Management)</span>
                    </div>
                  </button>
                  <button
                    onClick={() => handleRoleUpdate('viewer')}
                    className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span>Viewer (Read Only)</span>
                    </div>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Status Update Dropdown */}
          <div className="relative">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
              iconName="ToggleLeft"
              iconPosition="left"
              className="text-sm"
            >
              Update Status
              <svg 
                className={cn(
                  "ml-2 h-4 w-4 transition-transform",
                  isStatusDropdownOpen && "rotate-180"
                )} 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </Button>
            
            {isStatusDropdownOpen && (
              <div className="absolute top-full left-0 mt-1 w-40 bg-white rounded-md shadow-lg border border-border z-10">
                <div className="py-1">
                  <button
                    onClick={() => handleStatusUpdate('active')}
                    className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span>Activate</span>
                    </div>
                  </button>
                  <button
                    onClick={() => handleStatusUpdate('inactive')}
                    className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-gray-500 rounded-full"></div>
                      <span>Deactivate</span>
                    </div>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Delete Button */}
          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkDelete}
            iconName="Trash2"
            iconPosition="left"
            className="text-sm"
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsToolbar;